import { render, staticRenderFns } from "./BrokerAuthShell.vue?vue&type=template&id=2e156d39&scoped=true"
import script from "./BrokerAuthShell.vue?vue&type=script&lang=js"
export * from "./BrokerAuthShell.vue?vue&type=script&lang=js"
import style0 from "./BrokerAuthShell.vue?vue&type=style&index=0&id=2e156d39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e156d39",
  null
  
)

export default component.exports